export default __webpack_public_path__ + "static/media/seta-direita.8bd31705.svg";